import React from "react";

const Container: React.FC<
  React.PropsWithChildren<{
    onClick?: () => void;
    dataTestid?: string;
  }>
> = ({ children, onClick, dataTestid = "store-header" }) => (
  <header
    onClick={onClick}
    data-testid={dataTestid}
    className="print:hidden fixed z-[1000] w-full bg-blue shadow-[0_4px_5px_-1px_rgba(0,0,0,0.2)] md:left-0 md:right-0 md:h-auto md:bg-white"
  >
    <div className="flex w-full flex-wrap items-center gap-x-2 gap-y-3 px-3 py-3 md:mx-auto md:mt-[1.6rem] md:max-w-[1070px] md:items-start md:gap-x-[0.625rem] md:gap-y-1.5 md:pb-0 md:pt-0 lg:px-0">
      {children}
    </div>
  </header>
);

export default Container;
